import { createSlice } from "@reduxjs/toolkit";

import {
  countClickActionBuilder,
  getBusinessRulesVariablesBuilder,
} from "./builder";

import { SESSION_STORAGE_SELECTED_LOCALE } from "../../../utils/constants";

const commonSlice = createSlice({
  name: "commonInfo",
  initialState: {
    selectedLocale:
      localStorage.getItem(SESSION_STORAGE_SELECTED_LOCALE) ?? "ar",
    countryCode: "SA",
    countClickAction: {
      loading: false,
      error: null,
    },
    getBusinessRulesVariables: {
      loading: false,
      data: {},
    },
    redirectTo: "",
    sidebarOpen: true,
  },
  reducers: {
    setSelectedLocale: (state, action) => {
      state.selectedLocale = action.payload;
    },
    setSidebarOpen: (state, action) => {
      state.sidebarOpen = action.payload;
    },
    setCountryCode: (state, action) => {
      state.countryCode = action.payload;
    },
    setRedirectTo: (state, { payload }) => {
      const { redirectTo } = payload;
      state.redirectTo = redirectTo;
    },
  },
  extraReducers: (builder) => {
    getBusinessRulesVariablesBuilder(builder);
    countClickActionBuilder(builder);
  },
});

export const {
  setSidebarOpen,
  setSelectedLocale,
  setCountryCode,
  setRedirectTo,
} = commonSlice.actions;

export const selectSidebarOpen = (state) => state.commonInfo.sidebarOpen;
export const selectedLocale = (state) => state.commonInfo.selectedLocale;
export const selectedCountClickActionLoading = (state) =>
  state.commonInfo.countClickAction.loading;
export const selectBusinessRulesVariables = (state) =>
  state.commonInfo.getBusinessRulesVariables.data;
export const selectRedirectTo = (state) => state.commonInfo.redirectTo;

export default commonSlice.reducer;
